var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.833 9.75H9.667V7.5a2.2 2.2 0 0 1 .544-1.45 2.35 2.35 0 0 1 1.387-.768c.542-.09 1.1.01 1.573.278.474.27.834.691 1.015 1.192.104.281.32.511.599.64a1.2 1.2 0 0 0 1.283-.182q.171-.15.272-.352a1.1 1.1 0 0 0 .045-.86 4.53 4.53 0 0 0-2.035-2.38 4.8 4.8 0 0 0-3.148-.553 4.7 4.7 0 0 0-2.775 1.536A4.4 4.4 0 0 0 7.333 7.5v2.25H6.167a1.2 1.2 0 0 0-.825.33 1.09 1.09 0 0 0-.342.796v8.999a1.1 1.1 0 0 0 .342.796c.108.104.237.187.378.244q.214.085.447.085h11.666a1.2 1.2 0 0 0 .826-.33 1.089 1.089 0 0 0 .341-.796v-8.999a1.1 1.1 0 0 0-.341-.796 1.204 1.204 0 0 0-.825-.33m-1.166 9H7.333V12h9.334z"
  })));
};
export default SvgLock;